import React from "react";
import Header from "../Header/header";
import FormButtonStyle4 from "../../UIElements/FormButton";
import { useSelector } from "react-redux";
import moment from "moment";

function LoanApprovalProcesspage({ setCurrentStep }) {
  const aaSlice = useSelector((state) => state?.aa);
  console.log(aaSlice);
  const offer = aaSlice?.userData.dmi_offer;
  console.log(offer);
  const date = aaSlice?.userData?.updated_at;
  const loanId= aaSlice?. OpportunityName
  const handleClickNext = () => {
    setCurrentStep((prev) => prev + 1);
    // add navigation or logic here
  };

  const getEmiDate = () => {
    const disbursalDate = moment(date);

    if (!disbursalDate.isValid()) return null;

    if (disbursalDate.date() <= 20) {
      return disbursalDate.clone().add(1, "months").date(5);
    } else {
      return disbursalDate.clone().add(2, "months").date(5);
    }
  };

  return (
    <div className="min-h-[100dvh] flex flex-col mx-auto max-w-[400px] w-full bg-white">
      {/* Header */}
      <Header />

      {/* Loan Approval Card */}
      <div className=" relative min-h-[170px] max-h-[100dvh] bg-gradient-to-r from-[#004739] to-[#06a352] text-white w-[90%] mx-auto rounded-[20px] px-6 xs:px-6 mt-4 flex flex-col  text-center">
        <div className="flex flex-col items-start justify-start text-left max-w-[70%] xs:max-w-[73%]  my-auto">
          <h2 className="text-[29px] xs:text-[23px] font-bomstad-bold leading-6">
            Loan approval in progress
          </h2>
          <p className="text-[15px] xs:text-[12px] leading-[1.1] text-[#12F280]  font-atkinosn mt-3">
            Your loan will be disbursed soon — this may take 24–72 hours.
          </p>
        </div>
        <img
          src="/assets/img/1dddd672e554632db8ba88247aba438e1f3ae059.png"
          className="absolute top-2 right-4 xs:right-4 w-[120px] xs:w-[90px] h-[144px] xs:h-[144px] object-contain"
        />
      </div>

      {/* Loan Amount Section */}
      <div className="bg-white w-[90%] mx-auto  rounded-2xl border  px-10 py-5 mt-2">
        {/* Logo */}
        <div className="flex justify-center pb-3 border-b border-gray-200">
          <img
            src="/assets/img/dmiicon.png"
            alt="DMI Finance logo"
            className="h-[38px] w-auto"
          />
        </div>

        {/* Loan Amount Title */}
        <div className="py-3.5 text-center border-b font-atkinson border-gray-200">
          <p className="text-[#006F59] text-[16px] font-medium">Loan Amount</p>
          <p className="text-[35px] font-atkinson-bold font-bold">
            ₹{Number(offer?.amount).toLocaleString("en-IN")}
            <span className="">*</span>
          </p>
        </div>

        {/* Tenure & EMI */}
        <div className="py-3.5 text-[14px] text-[#000000] text-center font-medium border-b border-gray-200">
          <p>
            Tenure: {offer?.tenure} Months &nbsp; | &nbsp; EMI: ₹
            {Number(Number(offer?.emi).toFixed(2)).toLocaleString("en-IN", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </p>
        </div>

        {/* Interest Rate */}
        <div className="py-3.5 text-[14px] text-[#000000] text-center border-b border-gray-200">
          <p>Interest Rate: {offer?.interest}%</p>
        </div>

        {/* Loan ID (no separator below) */}
        <div className="pt-3.5 text-[10px] text-[#B3B3B3] text-center">
          <p>Loan ID: {loanId}</p>
        </div>
      </div>

      {/* Repayment Details */}
      <div className="bg-white w-[90%] mx-auto rounded-2xl border px-10 py-3 mt-2">
        {/* Title */}
        <div className="pb-3 border-b border-gray-200">
          <h3 className="text-center text-lg font-semibold text-green-800">
            Repayment Details
          </h3>
        </div>

        {/* EMI */}
        <div className="flex justify-between py-3.5 text-[14px] text-[#000000] border-b border-gray-200">
          <span>EMI</span>
          <span>
            ₹
            {Number(Number(offer?.emi).toFixed(2)).toLocaleString("en-IN", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
            *
          </span>
        </div>

        {/* First EMI Date */}
        <div className="flex justify-between py-3.5 text-[14px] text-[#000000]">
          <span>First EMI Date</span>
          <span>
            {<span>{getEmiDate()?.format("MMM D, YYYY") || "N/A"}</span>}
          </span>
        </div>
      </div>

      {/* Button */}
      <div className="mt-2 mb-5">
        <FormButtonStyle4
          text="Next"
          onClick={handleClickNext}
          className="w-full font-atkinson"
        />
      </div>
    </div>
  );
}

export default LoanApprovalProcesspage;
